function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 17.3309V7.99761C21.9996 7.58843 21.8916 7.18655 21.6868 6.8323C21.482 6.47804 21.1877 6.18386 20.8333 5.97927L12.6667 1.31261C12.312 1.10781 11.9096 1 11.5 1C11.0904 1 10.688 1.10781 10.3333 1.31261L2.16667 5.97927C1.81231 6.18386 1.51798 6.47804 1.31321 6.8323C1.10843 7.18655 1.00042 7.58843 1 7.99761V17.3309C1.00042 17.7401 1.10843 18.142 1.31321 18.4962C1.51798 18.8505 1.81231 19.1447 2.16667 19.3493L10.3333 24.0159C10.688 24.2207 11.0904 24.3285 11.5 24.3285C11.9096 24.3285 12.312 24.2207 12.6667 24.0159L20.8333 19.3493C21.1877 19.1447 21.482 18.8505 21.6868 18.4962C21.8916 18.142 21.9996 17.7401 22 17.3309Z",
  stroke: "#431288",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.31494 6.78428L11.4999 12.6759L21.6849 6.78428",
  stroke: "#431288",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4995 24.4243V12.6643",
  stroke: "#431288",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgSummaryIcon = function SvgSummaryIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSummaryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/summary-icon.95ca125a.svg";
export { ForwardRef as ReactComponent };